import { render, staticRenderFns } from "./Study.vue?vue&type=template&id=2c8c0aad&scoped=true&"
import script from "./Study.vue?vue&type=script&lang=js&"
export * from "./Study.vue?vue&type=script&lang=js&"
import style0 from "./Study.vue?vue&type=style&index=0&id=2c8c0aad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c0aad",
  null
  
)

export default component.exports